import React, { useState } from "react";
import "./sub.css";
import Api from "../../../Data/Api";

export default function Subscribe() {
  const [subscription, setSubscription] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [status, setStatus] = useState("idle");

  const handleChange = ({ target: { name, value } }) => {
    setSubscription((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus("sending");

    try {
      await Api.sendNewsletterSubscription(subscription);
      setStatus("success");
      setSubscription({ name: "", email: "", phone: "" });
    } catch (error) {
      console.error("Newsletter subscription failed:", error);
      setStatus("error");
    }
  };

  return (
    <section className="subscribe-section" aria-labelledby="subscribe-heading">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Left: Text */}
          <div
            className="col-lg-6 col-md-12 subscribe-text-col"
            data-aos="fade-right"
          >
            <div className="subscribe-tag">
              <ion-icon name="mail-outline"></ion-icon>
              Newsletter
            </div>
            <h2 className="subscribe-heading" id="subscribe-heading">
              Join Our Yitalife <br /> Bulletin!
            </h2>
            <p className="subscribe-subtext">
              Stay informed with exciting health tips, lifestyle education,
              community outreach updates, and special offers from Yita Life
              Medical Services - delivered straight to your inbox.
            </p>
          </div>

          {/* Right: Form */}
          <div
            className="col-lg-6 col-md-12"
            data-aos="fade-left"
            data-aos-delay="100"
          >
            <div className="subscribe-form-card">
              <h3>Sign Up for Health Updates</h3>

              <form className="subscribe-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="sub-name">Full Name</label>
                  <input
                    id="sub-name"
                    type="text"
                    name="name"
                    value={subscription.name}
                    placeholder="e.g. Jane Doe"
                    autoComplete="name"
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="sub-email">Email Address</label>
                  <input
                    id="sub-email"
                    type="email"
                    name="email"
                    value={subscription.email}
                    placeholder="e.g. jane@example.com"
                    autoComplete="email"
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="sub-phone">Phone Number (Optional)</label>
                  <input
                    id="sub-phone"
                    type="tel"
                    name="phone"
                    value={subscription.phone}
                    placeholder="e.g. +256 700 000 000"
                    autoComplete="tel"
                    onChange={handleChange}
                  />
                </div>

                <button
                  type="submit"
                  className="subscribe-submit-btn"
                  disabled={status === "sending"}
                >
                  {status === "sending" ? "Subscribing..." : "Subscribe Now"}
                </button>

                {status === "success" && (
                  <p className="subscribe-status success" role="status">
                    Thank you. You are on the newsletter list.
                  </p>
                )}
                {status === "error" && (
                  <p className="subscribe-status error" role="alert">
                    We could not submit your details. Please try again.
                  </p>
                )}

                <p className="subscribe-privacy">
                  We respect your privacy. Unsubscribe at any time.
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
